import { digObject, generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useAgencyProvider from '@hooks/useAgencyProvider'
import useProviderPriceList from '@hooks/useProviderPriceList'
import useSelector from '@hooks/useSelector'

import type { AgencyProviderModel } from '@models/types'

import { confirmDelete } from '@functions/entity'

const ProviderPriceListItem = (props: { agencyProvider: AgencyProviderModel }) => {
  const { agencyProvider } = props
  const { callbacks: { createOrEditAgencyProvider, deleteAgencyProvider } } = useAgencyProvider(agencyProvider)

  const providerPriceLists = useSelector(reduxState => reduxState.entities.providerPriceLists)
  const providerPriceList = providerPriceLists[agencyProvider.provider_price_list_id!]

  const providerPriceListPayload = useProviderPriceList(providerPriceList)
  const {
    service,
    urls: { editProviderPriceListUrl },
  } = providerPriceListPayload

  const id = digObject(providerPriceList, 'id', '')
  const title = digObject(providerPriceList, 'title', '')

  if (!providerPriceList) return null

  const confirmDeletePayload = {
    callbacks: { deleteFn: deleteAgencyProvider },
    strings: {
      confirmString: 'Are you sure?',
      deleteString: 'Remove',
      entityName: 'Provider Price List',
    },
  }

  return (
    <DashboardModuleListItem
      title={title}
      // @ts-expect-error TS2339
      secondaryText={`${service?.title}`}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        # {id}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditAgencyProvider()}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}
export default ProviderPriceListItem
